import { isPlatformBrowser } from '@angular/common'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'

import { Observable } from 'rxjs'

import { ConfigService } from '../services'

@Injectable()
export class BaseApiInterceptor implements HttpInterceptor {
  private readonly configService = inject(ConfigService)
  private readonly platformId = inject<Object>(PLATFORM_ID)

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (/^\.?\/?assets.*/.test(req.url)) {
      return next.handle(req)
    }

    const { api2Url: apiUrl, ssrApi2Url: ssrApiUrl } = this.configService.config

    const platformApiUrl = isPlatformBrowser(this.platformId) ? apiUrl : ssrApiUrl

    // Clean up URL construction to avoid double slashes and trailing slash issues
    const cleanApiUrl = platformApiUrl.endsWith('/') ? platformApiUrl.slice(0, -1) : platformApiUrl
    const cleanReqUrl = req.url.startsWith('/') ? req.url.slice(1) : req.url
    const finalUrl = `${cleanApiUrl}/${cleanReqUrl}`

    const reqClone = req.clone({
      url: finalUrl,
    })

    return next.handle(reqClone)
  }
}
